(function () {
  class wheelBonus extends PIXI.Container {
    constructor(segmentCount, path, buyABonusWheel) {
      super();

      this._path = path;

      this._buyABonusWheel = buyABonusWheel;

      this._assetsNamePrefix = `${path}:wheelBonusContainer:wheelAssets:`;

      this._wedgePathPrefix = 'graphics/Generic/WheelBonus/Wedges/';
      this._bonusBuyWedgePathPrefix = 'graphics/Generic/WheelBonus/Wedges/BonusBuy/';

      this._wheelBonusContainer = null;
      this._wheelSpinnerContainer = null;
      this._wheelWedgesContainer = null;
      this._wheelPigAmtPanel = null;
      this._wheelPigAmtText = null;

      this._wheelSegmentInfo = {};

      this._colorAssetConditions = [
        {
          condition: { red: true, green: true, blue: true },
          assetName: 'RGB_Wedge.png',
          popupPigs: ['GreenPig', 'RedPig', 'BluePig'],
        },
        {
          condition: { red: false, green: true, blue: true },
          assetName: 'Pig_BG_Wedge.png',
          popupPigs: ['GreenPig', 'BluePig'],
        },
        {
          condition: { red: true, green: false, blue: true },
          assetName: 'Pig_RB_Wedge.png',
          popupPigs: ['RedPig', 'BluePig'],
        },
        {
          condition: { red: true, green: true, blue: false },
          assetName: 'Pig_RG_Wedge.png',
          popupPigs: ['RedPig', 'GreenPig'],
        },
        { condition: { red: true, green: false, blue: false }, assetName: 'Pig_Red_Wedge.png', popupPigs: ['RedPig'] },
        {
          condition: { red: false, green: false, blue: true },
          assetName: 'Pig_Blue_Wedge.png',
          popupPigs: ['BluePig'],
        },
        {
          condition: { red: false, green: true, blue: false },
          assetName: 'Pig_Green_Wedge.png',
          popupPigs: ['GreenPig'],
        },
      ];

      this._pigFeatureSpineNames = ['GreenPig', 'RedPig', 'BluePig'];

      this._standardWedgeMultiplierConfig = [
        { min: 0, max: 5, asset: 'Plain_Wedge.png' },
        { min: 6, max: 10, asset: 'Magenta_Wedge.png' },
        { min: 11, max: 15, asset: 'Teal_Wedge.png' },
        { min: 16, max: Infinity, asset: 'Purple_Wedge.png' },
      ];
      this._plainWedgeAssetNames = ['Magenta_Wedge'];

      //current data
      this._spinIndices = null;
      this._currentInitialWheel = null;
      this._currentFinalWheel = null;
      this._numUpgrades = null;

      //spinner
      this._segmentCount = segmentCount;
      this._segmentAngle = (Math.PI * 2) / this._segmentCount;
      this._spinCount = 5;
      this._currentSegmentIndex = segmentCount - 1;
      this._wheelRadius = 400;
      this._wheelCentreOffset = 8;

      //assets
      this._introPigSprites = [];
      this._pigFeatureSpines = {
        GreenPig: null,
        RedPig: null,
        BluePig: null,
      };
      this._wheelPulseParticle = null;

      //pooled assets
      this._collectSegmentPool = [];
      this._glowSegmentPool = [];
      this._goldPigPool = [];

      // temp multiplier award text
      this._tempMultiAwardText = null;

      //tween configs
      this._introAnimationConfig = {
        landscape: {
          showWheel: {
            initialShow: { y: 650, duration: 0.5 },
            scaleDown: { x: 0.6, y: 0.6, duration: 1, ease: 'sine.in' },
            moveUp: { y: 370, duration: 0.8, ease: 'sine.in' },
          },
          spinReady: {
            scaleUp: { x: 0.95, y: 0.95, duration: 1 },
            moveDown: { y: 745, duration: 1, ease: 'back.out(1)' },
          },
        },
        portrait: {
          showWheel: {
            initialShow: { y: 880, duration: 0.5 },
            scaleDown: { x: 0.6, y: 0.6, duration: 1, ease: 'sine.in' },
            moveUp: { y: 846, duration: 0.8, ease: 'sine.in' },
          },
        },
        shared: {
          postUpgradePulse: {
            scaleDown: { x: 0.5, y: 0.5, duration: 0.25, ease: 'power1.inOut' },
            scaleUp: { x: 0.6, y: 0.6, duration: 0.25, ease: 'back.out(10)' },
          },
        },
      };

      // TIMELINES & TWEEN PROMISES
      this._introAnimationTimeline = null;
      this._introAnimationTimelineEnd = null;
      this._introAnimationTimelineEndLandscapeOnly = null;
      this._featureFinishedTimeline = null;

      // console.log('%c WheelBonusClass', 'color: red', this);

      this.readyToPlay = false;
      this._wheelSpinning = false;
      this._wheelOnScreen = false;
      this._performingUpgrades = false;

      this._totalWinCount = 0;
    }

    initialise() {
      const self = this;
      messageBus.subscribe('spinner:GameConfigEvent', () => {
        self.onLayoutComplete();
      });
      messageBus.subscribe(this._buyABonusWheel ? 'feature:buyBonusWheel' : 'feature:wheel', (task) => {
        if (this._buyABonusWheel) {
          resourceManager.getController('inputOverlord').setState('freespinsIntro');
        }
        this.processWheel(task);
      });
      Reflex.registerEventHandler('orientationChange', this._orientationChange.bind(this));
    }

    createWheelSegmentInfo(numSegments) {
      const wheelSegmentTemplate = () => ({
        x: null,
        y: null,
        angle: null,
        assets: {
          wedgeSprite: { sprite: null, text: null },
          upgradeSpriteName: null,
          collectSprite: null,
        },
        isCollect: false,
        isFeature: false,
        originalNumPigs: 0,
        afterUpgradeNumPigs: 0,
        popupPigs: [],
      });

      const wheelSegmentInfo = {};
      for (let i = 0; i < numSegments; i++) {
        wheelSegmentInfo[i] = wheelSegmentTemplate();
      }
      return wheelSegmentInfo;
    }

    onLayoutComplete() {
      this._freeSpinsIntro = resourceManager.get('freeSpinsIntro');

      this._wheelBonusContainer = resourceManager.get(this._path);
      this._wheelSpinnerContainer = resourceManager.get(`${this._assetsNamePrefix}wheelSpinnerContainer`);
      this._wheelWedgesContainer = resourceManager.get(
        `${this._assetsNamePrefix}wheelSpinnerContainer:wheelWedgesContainer`
      );

      if (!this._buyABonusWheel) {
        this._wheelPigAmtPanel = resourceManager.get(`${this._path}:wheelBonusContainer:wheelAssets:wheelPigAmtPanel`);
        this._wheelPigAmtText = resourceManager.get(`${this._path}:wheelBonusContainer:wheelAssets:pigAmtText`);
      }

      const pigPopupContainer = resourceManager.get(`${this._path}:popupPigsContainer`);

      if (!this._buyABonusWheel) {
        this._collectSegmentPool = wheelBonusPools.createWheelSegmentPool(
          'collectSegment',
          this._path,
          'Collect.png',
          12,
          this._wheelWedgesContainer
        );
        this._goldPigPool = wheelBonusPools.createGoldPigPool('goldPig', this._path, 33, this._wheelBonusContainer);

        this._glowSegmentPool = wheelBonusPools.createWheelSegmentMoviePool(
          'glowAnimation',
          this._path,
          'wheelSegmentGlow',
          12,
          this._wheelWedgesContainer
        );
      }

      this._wheelPulseParticle = particleManager.createEmitter(
        'wheelPulseParticle',
        this._wheelBonusContainer,
        0,
        0,
        false
      );
      this._wheelPulseParticle.particleEmitter.emit = false;
      this._wheelPulseParticle.scale.set(3);

      Object.entries(this._pigFeatureSpines).forEach(([assetName]) => {
        const spine = resourceManager.createObject('spine', assetName, pigPopupContainer, {
          name: assetName,
          defaultAnimation: 'Idle2',
          x: 0,
          y: 140,
          scaleY: 0.15,
        });
        spine.visible = false;
        this._pigFeatureSpines[assetName] = spine;
      });

      // temp multiplier award text
      this._tempMultiAwardText = resourceManager.createObject(
        'text',
        `${this._path}:tempMultiAwardText`,
        this._wheelBonusContainer,
        {
          scale: 0,
          text: '',
          x: 0,
          y: 0,
          fontDefinition: 'wheelSegmentValue',
        }
      );
      this._tempMultiAwardText.anchor.set(0.5, 0);

      // generate the initial wheelSegmentInfo object
      this._wheelSegmentInfo = this.createWheelSegmentInfo(this._segmentCount);

      Object.entries(this._wheelSegmentInfo).forEach(([key]) => {
        const index = parseInt(key, 10);
        const angle = index * this._segmentAngle + this._segmentAngle / 2 - Math.PI / 2;
        const x = (Math.cos(angle) * this._wheelRadius) / 2;
        const y = (Math.sin(angle) * this._wheelRadius) / 2 - this._wheelCentreOffset;

        const segment = this._wheelSegmentInfo[key];
        segment.x = x;
        segment.y = y;
        segment.rotation = angle + Math.PI / 2;
      });

      this._wheelSpinnerContainer.pivot.set(0, -this._wheelCentreOffset);
    }

    /**
     * Get asset name for the desired wheel section
     * @param {*} section - wheel segment object
     * @returns - Section Asset data
     */
    _getAssetNameForSection(section) {
      const isFeature = this._colorAssetConditions.find(
        ({ condition }) =>
          condition.red === section.red && condition.green === section.green && condition.blue === section.blue
      );

      const sectionAsset = { isFeature: false, assetName: '', popupPigs: [], numPigs: 0 };

      if (isFeature) {
        sectionAsset.isFeature = true;
        sectionAsset.assetName = isFeature.assetName;
        sectionAsset.popupPigs = isFeature.popupPigs;
      } else {
        const cash = section.cash;
        const cashMultiplier = this._convertCashValueToMultiplier(cash);
        sectionAsset.assetName = this._standardWedgeMultiplierConfig.find(
          (config) => cashMultiplier >= config.min && cashMultiplier <= config.max
        ).asset;
      }

      const colorKeys = ['blue', 'green', 'red'];
      sectionAsset.numPigs = colorKeys.reduce((count, color) => count + (section[color] === true ? 1 : 0), 0);

      return sectionAsset;
    }

    /**
     * Convert the wheel segment cash value to its respective multiplier
     * @param {Number} cashValue
     * @returns - Multipler value
     */
    _convertCashValueToMultiplier(cashValue) {
      if (!cashValue) return;
      const stake = gameController.globalHelperGetBaseStake();
      const cashToMulti = cashValue / stake;

      return cashToMulti;
    }

    /**
     * Set the initial state of the wheel segments
     */
    async processWheel(task) {
      gameController.cancelAutoplay();

      this._wheelTask = task;
      this._wheelTask.join();

      // this is probably still running
      await gameController.updatingGoldPigPromise;

      const wheelData = task.data.data;

      const { spinIndexes, initialWheel, finalWheel, numWheelUpgrades, baseWinnings } = wheelData;
      this._spinIndices = spinIndexes;

      this._currentInitialWheel = initialWheel;
      this._currentFinalWheel = finalWheel;

      const upgradeSegmentUpgrades = this._getWheelSegmentUpgrades(initialWheel, finalWheel);
      this._numUpgrades = this._buyABonusWheel ? 0 : numWheelUpgrades;

      this._totalWinCount = baseWinnings;

      Object.entries(this._wheelSegmentInfo).forEach(([key, { assets, x, y, rotation }]) => {
        const index = Number(key);

        // dont create sprite if one already exists
        if (assets.wedgeSprite.sprite) {
          this._updateWheelSegment(index, this._wheelSegmentInfo);
        } else {
          this._createWheelSegment(index, x, y, rotation, this._wheelSegmentInfo);
        }

        if (upgradeSegmentUpgrades.length) {
          const upgradeSegment = upgradeSegmentUpgrades.find((segment) => segment.index === index);
          if (upgradeSegment) {
            // this._createWheelSegment(upgradeSegment.index, x, y, rotation, true);
            const { assetName, popupPigs, numPigs } = this._getAssetNameForSection(upgradeSegment);
            this._wheelSegmentInfo[index].assets.upgradeSpriteName = assetName;
            this._wheelSegmentInfo[index].isFeature = true;
            this._wheelSegmentInfo[index].popupPigs = popupPigs;
            this._wheelSegmentInfo[index].afterUpgradeNumPigs = numPigs;
          }
        }
      });

      this.readyToPlay = true;
      await this._wheelEntry();

      // play through the wheel bonus animations
      await this.introAnimation(this._wheelSegmentInfo);
      await this.startSpins(this._wheelSegmentInfo);
      await this._outroAnimation(this._wheelSegmentInfo);

      // and then re-enable the spin button once wheel has moved away regardless of orientation
      systemData.hideSpinButtonInPortait = false;
      resourceManager.get('buttonContainer:buttonBar:spinButton').visible = true;

      this._wheelTask.leave();
    }

    /**
     * Handles playing pig entry animation/feature popup panel
     */
    async _wheelEntry() {
      await gameController.playPigActivateAnimation(['gold']);

      // if we are in portrait mode we need to hide the spin button
      systemData.hideSpinButtonInPortait = true;
      if (!systemData.isLandscape) {
        resourceManager.get('buttonContainer:buttonBar:spinButton').visible = false;
      }

      if (!gameController.inBuyABonus) {
        // show intro popup
        const data = {
          spinsAwarded: this._spinIndices.length,
          featureType: 'wheel',
          numUpgrades: this._numUpgrades,
        };
        await new Promise((res) => {
          this._freeSpinsIntro.startIntro(res, data);
        });
      } else {
        musicManager.playWheelTune();
      }
    }

    /**
     * Update a segment on the wheel
     * @param {*} segmentIndex
     */
    _updateWheelSegment(segmentIndex, wheelSegmentInfoEx) {
      const wheelSegment = wheelSegmentInfoEx[segmentIndex];
      const wheelSection = this._currentInitialWheel.wheelSections[segmentIndex];

      const { assetName, isFeature, popupPigs, numPigs } = this._getAssetNameForSection(wheelSection);

      const wedgePathPrefix = this._buyABonusWheel ? this._bonusBuyWedgePathPrefix : this._wedgePathPrefix;
      wheelSegment.assets.wedgeSprite.sprite.texture = PIXI.Texture.from(`${wedgePathPrefix}${assetName}`);
      wheelSegment.isFeature = isFeature;
      wheelSegment.popupPigs = popupPigs;
      wheelSegment.originalNumPigs = numPigs;
      const cash = wheelSection.cash;
      const cashMultiplier = this._convertCashValueToMultiplier(cash);

      wheelSegment.assets.wedgeSprite.text.text = cash ? `${String(cashMultiplier).split('').join('\n')}\nX` : '';

      // Because we are using a shared pool of sprites we need to reset the text y position so it doesn't stay at -60 if it was a feature before
      wheelSegment.assets.wedgeSprite.text.y = isFeature ? -60 : -170;
    }

    /**
     * Create a segment for the desired wheel location
     * @param {*} segmentIndex - Index of the wheel segment
     * @param {*} x  - x
     * @param {*} y  - y
     * @param {*} rotation - rotation
     */
    _createWheelSegment(segmentIndex, x, y, rotation, wheelSegmentInfoEx) {
      const wheelSegmentInfo = wheelSegmentInfoEx[segmentIndex];
      const wedgeAssets = wheelSegmentInfo.assets.wedgeSprite;

      const { isFeature, assetName, popupPigs, numPigs } = this._getAssetNameForSection(
        this._currentInitialWheel.wheelSections[segmentIndex]
      );

      const cash = this._currentInitialWheel.wheelSections[segmentIndex].cash;
      const multiplierValue = this._convertCashValueToMultiplier(cash);

      const fileName = this._buyABonusWheel
        ? `WheelBonus/Wedges/BonusBuy/${assetName}`
        : `WheelBonus/Wedges/${assetName}`;

      const wedgeSprite = resourceManager.createObject(
        'sprite',
        `${this._path}:wheelSegment${segmentIndex}wedgeSprite`,
        this._wheelWedgesContainer,
        {
          anchor: 0.5,
          fileName: fileName,
          x,
          y,
        }
      );
      wedgeSprite.rotation = rotation;
      wedgeAssets.sprite = wedgeSprite;

      // THE WEDGE ASSETS FOR BUY A BONUS WHEEL ARE TOO BIG
      if (this._buyABonusWheel) {
        wedgeSprite.scale.set(0.74);
      }

      //create wedge text
      const wedgeText = resourceManager.createObject(
        'text',
        `${this._path}:wheelSegment${segmentIndex}WedgeText`,
        wedgeSprite,
        {
          text: cash ? `${String(multiplierValue).split('').join('\n')}\nX` : '',
          x: 0,
          y: isFeature ? -60 : -170,
          fontDefinition: 'wheelSegmentValue',
        }
      );
      wedgeText.anchor.set(0.5, 0);
      wedgeAssets.text = wedgeText;

      wheelSegmentInfo.isFeature = isFeature;
      wheelSegmentInfo.originalNumPigs = numPigs;

      if (isFeature) {
        wheelSegmentInfo.popupPigs = popupPigs;
      }
    }

    /**
     * The initial showing of the wheel tween timeline
     * @param {*} showWheelConfig
     */
    _showWheelTween(showWheelConfig) {
      const showWheelTimeline = gsap.timeline();
      showWheelTimeline
        .to(this._wheelBonusContainer, { ...showWheelConfig.initialShow })
        .to(this._wheelBonusContainer.scale, { ...showWheelConfig.scaleDown })
        .to(this._wheelBonusContainer, { ...showWheelConfig.moveUp }, '<+0.2');

      return showWheelTimeline;
    }

    /**
     * Tweening the upgrade pigs to the panel timline
     * @returns timeline
     */
    _tweenPigsToPanelTweens() {
      const tweenPigsToPanelTweens = gsap.timeline();
      // tween pigs
      const firstPigStart = '<+0.90';
      const stagger = 0.1;
      tweenPigsToPanelTweens.addLabel('firstPig', firstPigStart);

      this.playedPiggiesSFX = false;

      this._introPigSprites.forEach((pigSprite, index) => {
        pigSprite.visible = true;

        // start moving pig to x:0, y:0 and begin scaling up at the same time
        const startTime = `firstPig+=${index * stagger}`;
        const scaleDownStart = `firstPig+=${index * stagger + 0.3}`;
        tweenPigsToPanelTweens
          .call(
            () => {
              if (!this.playedPiggiesSFX) {
                if (this._introPigSprites.length > 5) {
                  soundManager.play('piggies3');
                } else if (this._introPigSprites.length > 3) {
                  soundManager.play('piggies2');
                } else {
                  soundManager.play('piggies1');
                }
                this.playedPiggiesSFX = true;
              }

              soundManager.play('wheelAddPig');
            },
            [],
            '<'
          )
          .to(pigSprite, { x: 0, y: 0, duration: 0.6, ease: 'power1.inOut' }, startTime)
          .to(pigSprite.scale, { x: 1.8, y: 1.8, duration: 0.4, ease: 'sine.out' }, '<')
          .to(pigSprite.scale, { x: 0, y: 0, duration: 0.2, ease: 'sine.in' }, scaleDownStart)
          .call(
            () => {
              this._wheelPigAmtText.text = index + 1;
            },
            [],
            '<'
          );

        if (index === 0) {
          tweenPigsToPanelTweens.to(
            this._wheelBonusContainer.scale,
            { y: 0.58, x: 0.58, yoyo: true, duration: 0.05, repeat: this._introPigSprites.length * 2 - 1 },
            '<'
          );
        }
      });

      return tweenPigsToPanelTweens;
    }

    /**
     * Build the intro animation timeline
     * Retriggers on orientation change to readjust tween and track progress
     */
    _buildIntroAnimationTimeline() {
      const isLandscape = systemData.isLandscape;
      const showWheel = this._introAnimationConfig[isLandscape ? 'landscape' : 'portrait'].showWheel;

      let progress = 0;

      if (this._introAnimationTimeline) {
        progress = this._introAnimationTimeline.progress();
        this._introAnimationTimeline.kill();
      }

      this._introAnimationTimeline = gsap
        .timeline({ onComplete: this._introAnimResolve })
        .add(this._showWheelTween(showWheel));

      if (!this._buyABonusWheel) {
        this._introAnimationTimeline.add(this._tweenPigsToPanelTweens());
      }

      this._introAnimationTimeline.progress(progress);
    }

    /**
     * Moves the wheel down after the intro to get ready for spinning (current only moves down in landscape)
     * Gets called on orientation change to handle positioning
     * @param {Boolean} orientationChange
     */
    _moveDownWheelEndAnimation(orientationChange = false) {
      const isLandscape = systemData.isLandscape;

      if (isLandscape) {
        const spinReadyConfig = this._introAnimationConfig.landscape.spinReady;
        if (orientationChange) {
          const y = this._introAnimationConfig.landscape.showWheel.moveUp.y;
          this._wheelBonusContainer.y = y;
        }
        this._introAnimationTimelineEndLandscapeOnly = gsap
          .timeline()
          .to(this._wheelBonusContainer.scale, { ...spinReadyConfig.scaleUp }, '+=0.5')
          .to(this._wheelBonusContainer, { ...spinReadyConfig.moveDown }, '<');
        this._introAnimationTimelineEnd.add(this._introAnimationTimelineEndLandscapeOnly);
      } else {
        if (this._introAnimationTimelineEndLandscapeOnly) {
          this._introAnimationTimelineEndLandscapeOnly.kill();
          this._introAnimationTimelineEndLandscapeOnly = null;
          this._introAnimationTimelineEnd.progress(1);
        }
        if (orientationChange) {
          const y = this._introAnimationConfig.portrait.showWheel.moveUp.y;
          this._wheelBonusContainer.y = y;
        }
        const landscapeOnlyTweenStarted = this._introAnimationTimelineEndLandscapeOnly?.progress() > 0;
        if (landscapeOnlyTweenStarted) {
          const scale = this._introAnimationConfig.portrait.showWheel.scaleDown.x;
          this._wheelBonusContainer.scale.set(scale);
        }
      }
    }

    /**
     * Play the wheels intro animation start of feature
     */
    async introAnimation(wheelSegmentInfoEx) {
      this._wheelOnScreen = true;
      // resolve/promise for the initial intro animation
      this._introAnimResolve = null;
      this._introAnimPromise = new Promise((res) => {
        this._introAnimResolve = res;
      });

      // resolve/promise for the ending (tweening out and being spin ready) animation
      this._introAnimEndResolve = null;
      this._introAnimEndPromise = new Promise((res) => {
        this._introAnimEndResolve = res;
      });

      // acquire the intro pig sprites and push to array for tweeing
      for (let i = 0; i < this._numUpgrades; i++) {
        const pigSprite = this._goldPigPool.acquire();
        this._introPigSprites.push(pigSprite);
      }

      if (!this._buyABonusWheel) {
        this._wheelPigAmtText.text = 0;
      }

      // build & play the intro animation timeline (rebuilds on orientation change to continue tween with correct tween orientation config)
      if (gameController.inBuyABonus) {
        soundManager.play('wheelEnterBuyBonus');
      } else {
        soundManager.play('wheelEnter');
      }
      this._buildIntroAnimationTimeline();
      await this._introAnimPromise;
      this._introAnimationTimeline.kill();
      this._introAnimationTimeline = null;

      // release the upgrade pig sprites
      this._introPigSprites.forEach((pigSprite) => {
        this._goldPigPool.release(pigSprite);
      });
      this._introPigSprites = [];

      !this._buyABonusWheel && (await this._performSegmentUpgrades(wheelSegmentInfoEx)); // *Need assets for performing upgrades*

      // start intro animation end animations
      const postUpgradePulse = this._introAnimationConfig.shared.postUpgradePulse;
      this._introAnimationTimelineEnd = gsap.timeline({ onComplete: this._introAnimEndResolve });
      if (!this._buyABonusWheel) {
        this._introAnimationTimelineEnd.to([this._wheelPigAmtPanel.scale, this._wheelPigAmtText.scale], {
          x: 0,
          y: 0,
          duration: 0.25,
          ease: 'power1.inOut',
        });
      }
      this._introAnimationTimelineEnd
        .to(this._wheelBonusContainer.scale, { ...postUpgradePulse.scaleDown }, '<')
        .to(this._wheelBonusContainer.scale, { ...postUpgradePulse.scaleUp })
        .call(
          () => {
            if (!gameController.inBuyABonus) {
              soundManager.play('wheelHighlight');
            }
            this._wheelPulseParticle.particleEmitter.emit = true;
          },
          [],
          '<'
        );

      // get the wheel spin ready
      this._moveDownWheelEndAnimation();

      await this._introAnimEndPromise;

      if (!this._buyABonusWheel) {
        this._wheelPigAmtText.text = '';
      }

      this._introAnimationTimelineEnd.kill();
      this._introAnimationTimelineEnd = null;
      this._introAnimationTimelineEndLandscapeOnly = null;
    }

    /**
     * Upgrade segments on the wheel, destroying the initial and setting upgrades as the initial
     * @returns - Promise
     */
    async _performSegmentUpgrades(wheelSegmentInfoEx) {
      this._performingUpgrades = true;
      gameController.playPigActivateAnimation(['gold'], false);

      const upgradeSegments = Object.values(wheelSegmentInfoEx).filter(
        (segment) => segment.assets.upgradeSpriteName !== null
      );

      const glowAnims = [];
      const upgradeProms = upgradeSegments.map(async (upgradeSegment, index) => {
        const staggerIndex = index * 400;
        await timerManager.delayAsync(staggerIndex);

        soundManager.play('wheelUpgradeSegment');

        // Count down text
        const countDownTo =
          Number(this._wheelPigAmtText.text) - (upgradeSegment.afterUpgradeNumPigs - upgradeSegment.originalNumPigs);
        this._wheelPigAmtText.text = countDownTo;

        // Play glow animation
        await new Promise((res) => {
          const glowAnim = this._glowSegmentPool.acquire(
            upgradeSegment.x,
            upgradeSegment.y,
            upgradeSegment.rotation,
            res
          );
          glowAnim.visible = true;
          glowAnim.play();
          glowAnims.push(glowAnim);

          // Update to new upgrade asset
          timerManager.delayAsync(500, null, () => {
            const { assets, isFeature } = upgradeSegment;
            const wedgePathPrefix = this._buyABonusWheel ? this._bonusBuyWedgePathPrefix : this._wedgePathPrefix;
            assets.wedgeSprite.sprite.texture = PIXI.Texture.from(`${wedgePathPrefix}${assets.upgradeSpriteName}`);

            if (isFeature) {
              if (assets.wedgeSprite.text) {
                assets.wedgeSprite.text.y = -60;
              }
            }
          });
        });
      });

      await Promise.all(upgradeProms);
      glowAnims.forEach((glowAnim) => {
        this._glowSegmentPool.release(glowAnim);
      });

      this._performingUpgrades = false;
    }

    /**
     * Perform wheel upgrades at the beginning of the feature
     */
    _getWheelSegmentUpgrades(initialWheel, finalWheel) {
      const wheelUpgradeSegments = [];

      const stripExpended = (wheel) => ({
        wheelSections: wheel.wheelSections.map(({ expended, ...rest }) => rest),
      });

      const checkCurrentInitialWheel = stripExpended(initialWheel);
      const checkCurrentFinalWheel = stripExpended(finalWheel);

      checkCurrentInitialWheel.wheelSections.forEach((currentInitialSegment, index) => {
        const finalSegment = checkCurrentFinalWheel.wheelSections[index];
        const isUpgrade = JSON.stringify(currentInitialSegment) !== JSON.stringify(finalSegment);
        if (isUpgrade) {
          wheelUpgradeSegments.push({ index, ...finalSegment });
        }
      });

      return wheelUpgradeSegments;
    }

    /**
     * Spin the wheel to the desired segment index
     * @param {number} segmentIndexToLand - Segment index to land on 0-11
     * @param {boolean} firstSpin - Where this is the first wheel spin
     */
    async _spinWheel(segmentIndexToLand, firstSpin) {
      soundManager.play('wheelSpin');

      const fullRotationAmount = Math.PI * 2 * this._spinCount;
      const segmentUntilLandPosition = this._currentSegmentIndex - segmentIndexToLand;

      const toSegmentRotation =
        (firstSpin ? this._segmentAngle / 2 : 0) + this._segmentAngle * segmentUntilLandPosition;

      const finalRotation = this._wheelSpinnerContainer.rotation + fullRotationAmount + toSegmentRotation;

      this._currentSegmentIndex = segmentIndexToLand;

      //pullback
      const spinWheelTimeline = gsap.timeline();
      spinWheelTimeline
        .to(this._wheelSpinnerContainer, {
          duration: 0.5,
          rotation: this._wheelSpinnerContainer.rotation - this._segmentAngle / 2,
          ease: 'power2.out',
        })
        //spin wheel/land on correct segment
        .to(this._wheelSpinnerContainer, {
          duration: 4,
          rotation: finalRotation,
          ease: 'power4.inOut',
        });

      await spinWheelTimeline;
    }

    /**
     * Start spinning the wheels and awarding prizes
     */
    async startSpins(wheelSegmentInfoEx) {
      this._wheelSpinning = true;

      // Only process the first spin - feature ends after landing on any segment
      const segmentIndex = this._spinIndices[0];
      await this._spinWheel(segmentIndex, true);
      await this._handleSpinLand(segmentIndex, wheelSegmentInfoEx);

      this._wheelSpinning = false;
    }

    /**
     * Builds the outro animation tween (after wheel bonus has finished)
     * Retriggers on orientation change to reset tween positioning and track progress
     */
    _buildOutroAnimTween() {
      let progress = 0;

      if (this._featureFinishedTimeline) {
        progress = this._featureFinishedTimeline.progress();
        this._featureFinishedTimeline.kill();
      }
      // feature end, tween out wheel
      const wheelBonusHeight = this._wheelBonusContainer.height;
      const tweenUpAmount = wheelBonusHeight * 0.1; // tween up 10% of the wheel bonus height

      const currentLayout = layoutController.getCurrentLayout();
      const originalWheelBonusContainerPos = this._wheelBonusContainer.Props[currentLayout];
      const { position } = originalWheelBonusContainerPos;

      this._featureFinishedTimeline = gsap.timeline({ onComplete: this._outroAnimResolve });
      this._featureFinishedTimeline
        .to(this._wheelBonusContainer, { y: `-=${tweenUpAmount}`, duration: 0.3, ease: 'back.in(2)' })
        .to(this._wheelBonusContainer, { y: position.y, duration: 0.5 });

      this._featureFinishedTimeline.progress(progress);
    }

    /**
     * Outro animation when the wheel bonus has finished
     */
    async _outroAnimation(wheelSegmentInfoEx) {
      this._wheelOnScreen = false;
      this._outroAnimResolve = null;
      this._outroAnimPromise = new Promise((res) => {
        this._outroAnimResolve = res;
      });

      this._buildOutroAnimTween();

      await this._outroAnimPromise;
      // maybe we stop the tune here and bring back the original base level
      if (!this._wheelTask.data.data.didDeliverFeatures) {
        musicManager.stopWheelTune(false);
      } else {
        // if (!gameController.inBuyABonus) {
        //   musicManager.stopWheelTune(true);
        // }
      }
      this._featureFinishedTimeline.kill();
      this._featureFinishedTimeline = null;

      this._resetWheel(wheelSegmentInfoEx);
    }

    /**
     * Get wedge assets by segment index
     * @param {*} segmentIndex
     * @returns - wedgeSprite
     */
    _getWedgeAssetsBySegmentIndex(segmentIndex, wheelSegmentInfoEx) {
      const assets = wheelSegmentInfoEx[segmentIndex].assets;
      return assets.wedgeSprite;
    }

    /**
     * Handle landing on a segment
     * @param {*} segmentLandedIndex
     */
    async _handleSpinLand(segmentLandedIndex, wheelSegmentInfoEx) {
      const { text } = this._getWedgeAssetsBySegmentIndex(segmentLandedIndex, wheelSegmentInfoEx);
      const segmentLandedData = this._currentFinalWheel.wheelSections[segmentLandedIndex];
      const wheelSegmentInfo = wheelSegmentInfoEx[segmentLandedIndex];

      const cash = segmentLandedData.cash;
      const isFeature = wheelSegmentInfo.isFeature;

      // award segment multilier
      if (!wheelSegmentInfo.isCollect) {
        wheelSegmentInfo.isCollect = true;

        !isFeature && this._changeSegmentToCollect(segmentLandedIndex, cash !== null, wheelSegmentInfoEx);
        cash && (await this._awardSegmentMultiplier(text, cash));
        isFeature && (await this._awardFeatureSegment(segmentLandedIndex, wheelSegmentInfoEx));
      }
    }

    /**
     * Segment has landed on multiplier, award it
     * @param {*} text - Segment text asset
     * @param {Number} cash - Cash value
     */
    async _awardSegmentMultiplier(text, cash) {
      soundManager.play('wheelStopOnCash');

      const { x, y } = helpers.getLocalFromGlobalPosition(text, this._wheelBonusContainer);

      this._tempMultiAwardText.position.set(x, y);
      const cashMultiplier = this._convertCashValueToMultiplier(cash);
      this._tempMultiAwardText.text = `${String(cashMultiplier).split('').join('\n')}\nX`;

      const awardTimeline = gsap.timeline();
      awardTimeline
        .to(this._tempMultiAwardText.scale, { x: 3, y: 3, duration: 0.5, ease: 'power2.in' })
        .to(this._tempMultiAwardText, { y: 200, duration: 1, ease: 'back.in(2)' })
        .to(this._tempMultiAwardText, { alpha: 0, duration: 2 }, '<');

      timerManager.delayAsync(1000, null, () => {
        const win = cash;
        this._totalWinCount += win;
        gameController.totalWinnings += win;
        soundManager.play('wheelMoneyAddToMeter');
        gameData.winningsMeter.countUp(win, 300, () => {
          // soundManager.stop('creditCountUp');
          // soundManager.play('creditCountUpEnd');
        });
      });

      await awardTimeline;

      // set win amount to meter
      this._tempMultiAwardText.scale.set(0);
      this._tempMultiAwardText.text = '';
      this._tempMultiAwardText.alpha = 1;
    }

    /**
     * Award the feature segment when landed on
     * @param {*} segmentLandedIndex
     */
    async _awardFeatureSegment(segmentLandedIndex, wheelSegmentInfoEx) {
      const pigPopupContainer = resourceManager.get(`${this._path}:popupPigsContainer`);

      const popupPigsTweenConfig = {
        1: [{ y: -330, x: 0 }],
        2: [
          { y: -330, x: -140, scaleX: -0.15 },
          { y: -330, x: 140 },
        ],
        3: [
          { y: -330, x: -220, scaleX: -0.15, z: 0 },
          { y: -330, x: 0, z: 2 },
          { y: -330, x: 220, z: 1 },
        ],
      };

      // get piggie assets for this segment.
      const popupPigAssetNames = wheelSegmentInfoEx[segmentLandedIndex].popupPigs;

      const pigSpines = Object.entries(this._pigFeatureSpines)
        .filter(([assetName]) => popupPigAssetNames.includes(assetName))
        .map(([assetName, value]) => value);

      const soundsToPlay = {
        1: 'wheelStopOnPig',
        2: 'wheelStopOn2Pigs',
        3: 'wheelStopOn2Pigs',
      };

      soundManager.play(soundsToPlay[pigSpines.length]);

      if (pigSpines.length === 3) {
        pigSpines.forEach((pigSpine, index) => {
          const { z } = popupPigsTweenConfig[pigSpines.length][index];
          pigPopupContainer.setChildIndex(pigSpine, z);
        });
      }

      const showPigPopupPromises = pigSpines.map(async (pigSpine, index) => {
        const { y: tweenToY, x, scaleX } = popupPigsTweenConfig[popupPigAssetNames.length][index];
        pigSpine.scale.x = scaleX ?? 0.15;
        pigSpine.x = x;
        pigSpine.visible = true;

        //tween/play anims
        pigSpine.play('Win_React');
        await gsap.to(pigSpine, { y: tweenToY, duration: 0.8 });
        await gsap.to(pigSpine.scale, {
          x: pigSpine.scale.x * 1.1,
          y: pigSpine.scale.y * 1.1,
          duration: 0.2,
          delay: 1.5,
        });
      });

      await Promise.all(showPigPopupPromises);
    }

    /**
     * Change segment to a collect wedge
     * @param {Number} segmentLandedIndex
     * @param {Boolean} awardingCashFirst
     */
    async _changeSegmentToCollect(segmentLandedIndex, awardingCashFirst = false, wheelSegmentInfoEx) {
      const { assets } = wheelSegmentInfoEx[segmentLandedIndex];
      const initialWedge = assets.wedgeSprite;

      const collectSprite = this._collectSegmentPool.acquire(
        initialWedge.sprite.x,
        initialWedge.sprite.y,
        initialWedge.sprite.rotation
      );
      assets.collectSprite = collectSprite;
      const delay = awardingCashFirst ? 0.6 : 0;
      await gsap.to(collectSprite, { alpha: 1, duration: 1, delay });
    }

    /**
     * Reset the wheel ready for spinning again
     */
    _resetWheel(wheelSegmentInfoEx) {
      const currentLayout = layoutController.getCurrentLayout();

      // RESET WHEEL BONUS CONTAINER
      const originalWheelBonusContainerPos = this._wheelBonusContainer.Props[currentLayout];
      const { position: wbcP, scaleX: wbcScale } = originalWheelBonusContainerPos;

      this._wheelBonusContainer.position.set(wbcP.x, wbcP.y);
      this._wheelBonusContainer.scale.set(wbcScale);

      // RESET WHEEL SPINNER CONTAINER
      this._wheelSpinnerContainer.rotation = 0;

      // RESET WHEEL PIG AMOUNT PANEL
      if (!this._buyABonusWheel) {
        const originalWheelPigAmtPanelPos = this._wheelPigAmtPanel.Props[currentLayout];
        const { scaleX: wpapScaleX, scaleY: wpapScaleY } = originalWheelPigAmtPanelPos;
        this._wheelPigAmtPanel.scale.set(wpapScaleX, wpapScaleY);

        const originalWheelPigAmtTextPos = this._wheelPigAmtText.Props[currentLayout];
        const { scaleX: wpatScale } = originalWheelPigAmtTextPos;
        this._wheelPigAmtText.scale.set(wpatScale);
        this._wheelPigAmtText.text = 0;
      }

      // RESET PIG FEATURE SPINES
      Object.entries(this._pigFeatureSpines).forEach(([, spine]) => {
        spine.visible = false;
        spine.y = 140;
      });

      // RESET CURRENT DATA/SPIN DATA
      this._spinIndices = null;
      this._currentInitialWheel = null;
      this._currentFinalWheel = null;
      this._numUpgrades = null;
      this._currentSegmentIndex = this._segmentCount - 1;

      // RESET WHEEL SEGMENT INFO BACK TO NULLS (ASSETS ETC)
      Object.entries(wheelSegmentInfoEx).forEach(([key, segmentInfo]) => {
        segmentInfo.assets.upgradeSpriteName = null;
        if (segmentInfo.assets.collectSprite) {
          this._collectSegmentPool.release(segmentInfo.assets.collectSprite);
          segmentInfo.assets.collectSprite = null;
        }
        segmentInfo.isCollect = false;
        segmentInfo.isFeature = false;
        segmentInfo.popupPigs = [];
        segmentInfo.originalNumPigs = 0;
        segmentInfo.afterUpgradeNumPigs = 0;
      });

      this._totalWinCount = 0;
      this.readyToPlay = false;
    }

    /**
     * Handles setting wheel positioning and resetting tweens and resuming progress on orientation change
     * @param {Boolean} isLandscape
     */
    _orientationChange(isLandscape) {
      // make sure spin button is visible in landscape
      if (isLandscape) {
        resourceManager.get('buttonContainer:buttonBar:spinButton').visible = true;
      } else {
        // if wheel is still on screen in portrait mode hide spin button
        if (this._wheelOnScreen || systemData.hideSpinButtonInPortait) {
          resourceManager.get('buttonContainer:buttonBar:spinButton').visible = false;
        }
      }

      // set position for if wheel is spinning
      if (this._wheelSpinning) {
        let y, scale;
        if (isLandscape) {
          const spinReadyConfig = this._introAnimationConfig.landscape.spinReady;
          y = spinReadyConfig.moveDown.y;
          scale = spinReadyConfig.scaleUp.x;
        } else {
          const spinReadyConfig = this._introAnimationConfig.portrait.showWheel;
          y = spinReadyConfig.moveUp.y;
          scale = spinReadyConfig.scaleDown.x;
        }
        this._wheelBonusContainer.y = y;
        this._wheelBonusContainer.scale.set(scale);
      } else if (this._performingUpgrades) {
        let y, scale;
        if (isLandscape) {
          const showWheelConfig = this._introAnimationConfig.landscape.showWheel;
          y = showWheelConfig.moveUp.y;
          scale = showWheelConfig.scaleDown.x;
        } else {
          const showWheelConfig = this._introAnimationConfig.portrait.showWheel;
          y = showWheelConfig.moveUp.y;
          scale = showWheelConfig.scaleDown.x;
        }
        this._wheelBonusContainer.y = y;
        this._wheelBonusContainer.scale.set(scale);
      } else if (this._introAnimationTimeline) {
        this._buildIntroAnimationTimeline();
      } else if (this._introAnimationTimelineEnd) {
        this._moveDownWheelEndAnimation(true);
      } else if (this._featureFinishedTimeline) {
        this._buildOutroAnimTween();
      }
    }
  }

  create = function (json) {
    return new wheelBonus(json.numSegments, json.ID, json.buyABonusWheel);
  };

  initialise = function (json, container, resources) {
    container.initialise();
  };

  getFilesRequired = function (json) {
    return [];
  };

  resourceManager.registerObjectType('wheelBonus', create, initialise, getFilesRequired);
})();
